import React from 'react';
import { observer } from 'mobx-react';
import store from './FAQPage.store';
import FAQPage from './FAQPage';

export default observer(() => <FAQPage store={store} />);
